export default function (value) {
  return `${window.location.protocol}//${window.location.host}/${value}`;
}



// WEBPACK FOOTER //
// ./src/assets/plugin/filters/hrefFormat.js